import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByDeviceOsQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByDeviceOsQueryType,
  AnalyticsViewsByDeviceOsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByDeviceOsQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByDeviceOsQueryType,
    AnalyticsViewsByDeviceOsQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByDeviceOsQueryType,
    AnalyticsViewsByDeviceOsQueryVariablesType
  >(AnalyticsViewsByDeviceOsQuery, options);
};
